import React from 'react';
// components
import Iconify from '../../../../components/Iconify';
// ----------------------------------------------------------------------
import EventIcon from '@mui/icons-material/Event';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ArticleIcon from '@mui/icons-material/Article';
import GavelIcon from '@mui/icons-material/Gavel';
import LockIcon from '@mui/icons-material/Lock';
import SchoolIcon from '@mui/icons-material/School';
import DescriptionIcon from '@mui/icons-material/Description';
import { Stack } from '@mui/material';
import WbSunnyIcon from '@mui/icons-material/WbSunny';

const navConfig = {
  subheader: 'general',
  items: [
    { title: 'Twoje Dane', path: '/staff', icon: <Iconify icon={'carbon:user-avatar-filled-alt'} width={20} height={20} /> },
    { title: 'Sun Active', link: 'https://sun-sport.pl/pracuj-z-nami/sun-active/', icon: <WbSunnyIcon /> },
    { title: 'Turnusy/Terminy', path: '/staff/camps', icon: <Iconify icon={'tabler:mood-kid'} width={20} height={20} /> },
    { title: 'Rozliczenia', path: '/staff/settlements', icon: <EventIcon /> },
    { title: <Stack direction="column"><p>Dokumenty Personalne</p><p>(Uzupełnij)</p></Stack>, path: '/staff/personal-documents', icon: <ArticleIcon />, color: 'rgb(255, 95, 31)' },
    { title: <Stack direction="column"><p>Standardy Pracy</p><p>(Zapoznaj się)</p></Stack>, path: '/staff/work-standards', icon: <GavelIcon />, color: 'rgb(12, 175, 255)' },
    { title: <Stack direction="column"><p>Ochrona danych osobowych</p><p>(Zapoznaj się)</p></Stack>, path: '/staff/personal-data-protection-documents', icon: <LockIcon />, color: 'rgb(12, 175, 255)' },
    { title: <Stack direction="column"><p>Instrukcje organizacji obozów</p><p>(Zapoznaj się)</p></Stack>, path: '/staff/organizing-camps-instruction-documents', icon: <SchoolIcon />, color: 'rgb(12, 175, 255)' },
    { title: <Stack direction="column"><p>Niezbędniki</p><p>(Zapoznaj się)</p></Stack>, path: '/staff/essential-documents', icon: <FileCopyIcon />, color: 'rgb(12, 175, 255)' },
    { title: 'Dokumenty Dodatkowe', path: '/staff/additional-documents', icon: <DescriptionIcon /> }

  ],
  paths: [
    '/staff',
    '/staff/camps',
    '/staff/sun-active-points',
    '/staff/settlements',
    '/staff/personal-documents',
    '/staff/work-standards',
    '/staff/essential-documents',
    '/staff/additional-documents',
    '/staff/personal-data-protection-documents',
    '/staff/organizing-camps-instruction-documents'
  ]
};

export default navConfig;
